import { Injectable } from '@angular/core';
import { HttpEvent, HttpRequest, HttpHandler, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class tdrsHttpServerErrorInterceptor implements HttpInterceptor {

  // constructor(private _tdrsAuthenticationService: tdrsAuthenticationService) {
  constructor() {
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse) {
            return throwError(error);
        }
        return throwError(error);
      })
    );    
  }
}